import React, { useEffect, useState, useRef } from "react";
import {
    Col,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Row
} from "reactstrap";
import { AvForm, AvField } from 'availity-reactstrap-validation';
import Select from "react-select";
import moment from "moment"
import { toast } from "react-toastify"
import SalesRepsService from "services/Admin/SalesRepsService";
import { SuccessOk } from "configs/statusCode";

const FilterModal = ({ modal, toggle, onSumbit, filterData }) => {
    const [salesRepOptions, setSalesRepOptions] =useState([])
    const salesRepsService = new SalesRepsService()
    const [formState, setFormState] = useState({
        from_date: "",
        to_date: "",
        sales_rep_ids: ''
    })
    useEffect(() => {
         if (filterData ?.from_date ?.length) {
            setFormState((state) => ({ ...state, from_date: filterData.from_date }))
        }
        if (filterData ?.to_date ?.length) {
            setFormState((state) => ({ ...state, to_date: filterData.to_date }))
        }
        salesRepsService.getDropDown().then(res=>{
            let salesReps = []
            if(res && res.status === SuccessOk){
                res.data?.map(sales=> salesReps.push({label: sales.name, value: sales.id}))
                setSalesRepOptions([...salesReps])
            }
        })
        if(filterData ?.sales_rep_ids?.value){
            setFormState((state) => ({ ...state, sales_rep_ids: filterData ?.sales_rep_ids }))
        }
    }, []);

    const handleFieldChange = (e) => {
        setFormState({ ...formState, [e.target.name]: e.target.value })
    }

    const handleValidSubmit = () => {
        if (moment(formState.to_date).isBefore(formState.from_date)) {
            toast.error("Date range not valid")
            return
        }
        onSumbit(formState)
        toggle()

    }
    return (
        <AvForm className='form-horizontal' onValidSubmit={(e, v) => handleValidSubmit()} >
            <Modal isOpen={modal} toggle={toggle}
                className="rightModalSide scrollbar-container mt-0">
                <ModalHeader toggle={toggle}>
                    Appointments Filters
            </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={12} className='mb-3'>
                            <label>Sales Rep</label>
                            <Select
                                placeholder='Select'
                                options={salesRepOptions}
                                onChange={(e)=> setFormState({...formState, sales_rep_ids: e})}
                                value={formState.sales_rep_ids}
                            />
                        </Col>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='from_date'
                                    label="from Date"
                                    className='form-control'
                                    type='date'
                                    onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formState.from_date}/>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className='mb-3'>
                                <AvField
                                    name='to_date'
                                    label=" to Date"
                                    placeholder='Type Date'
                                    type='date'
                                    onChange={(e) => handleFieldChange(e)}
                                    bsSize="lg"
                                    value={formState.to_date}

                                />
                            </div>
                        </Col>
                    </Row>


                </ModalBody>
                <ModalFooter className="mt-4 px-0 d-flex justify-content-between">
                    <button
                        type='button'
                        className='btn btn-light w-120'
                        onClick={() => {
                            setFormState({
                                from_date: "",
                                to_date: "",
                                sales_rep_ids: ""
                            })
                            onSumbit({
                                from_date: "",
                                to_date: "",
                                sales_rep_ids: ""
                            })
                        }}>
                        Reset Filter
                       </button>
                    <button type='button'
                        onClick={() => {
                            handleValidSubmit()
                        }}
                        className='btn btn-success  w-120'>
                        Apply Filter
                    </button>
                </ModalFooter>

            </Modal>
        </AvForm>

    )
}
export default FilterModal